import './project.css';
import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { BASE_URL } from './axios';
import { AddProjectDetails, DeleteProject, UpdateProjectAllDetails, AddContractor, AddConsultant, UpdateContractor, UpdateConsultant, DeleteContractor, } from './ProjectsComponents';
import { useNavigate } from "react-router-dom";
import Dashboardnavbar from '../../layout/Navbar/Navbar';
import { Eye, CircularGrid, ProjectIcon } from '../../utils/ReusableSVGs';
import { Projects, SubCompany } from '../../utils/ReusableFilters';
import { sortProjects, formatRoundoffCrores, formatRoundoff, handleErrorToast } from '../../utils/ReusableFunctions';
import { formatDate, formattedDateLong } from '../../utils/DateFormattings';
import AllLetterDetails from "../AllLetterDetail/AllLetterDetail"
import { AddDepartment, AddEditProjectDepartment, CriticalActivityModal, CriticalActivityModalDelete, CriticalEditActivityModal, ProductionModalAdd, ProductionModalEdit, ProductionModalDelete } from '../AllLetterDetail/AllLetterModal';
import DepartmentTask from "./Department.jsx"
import { AddMOM, UpdateMOM, DeleteMOM, AddROB, UpdateROB, DeleteROB, AddMaterial, UpdateMaterial, DeleteMaterial } from "./AllProjectdetailsmodal.jsx"
import { DateRangePicker } from '../TicketManagement/TicketModelComponent.jsx';
const ProjectDataTableView = ({ subCompany, searchName, searchSort }) => {

    const [filteredProject, setFilteredProject] = useState([]);

    const [buffer, setBuffering] = useState(false);
    const [projectList, setProjectsList] = useState([])
    const navigate = useNavigate();
    const role = sessionStorage.getItem('role');

    const tableRef = useRef(null);


    const fetchProjects = async () => {
        setBuffering(true);
        // setFilteredProject([]); // Clear filtered data before fetching new data
        // setProjectsList([]);
        let endpoint = `${BASE_URL}/project_details/project/`;

        try {
            const response = await axios.get(endpoint);
            let filteredProjects = response.data;
            // switch (searchSort) {
            //     case "asc_pr":
            //         filteredProjects = sortProjects(filteredProjects, "site_prcode");
            //         break;
            //     case "desc_pr":
            //         filteredProjects = sortProjects(filteredProjects, "site_prcode").reverse();
            //         break;
            //     case "asc_short_name":
            //         filteredProjects = filteredProjects.sort((a, b) =>
            //             a.project_short_name.localeCompare(b.project_short_name)
            //         );
            //         break;
            //     case "desc_short_name":
            //         filteredProjects = filteredProjects.sort((a, b) =>
            //             b.project_short_name.localeCompare(a.project_short_name)
            //         );
            //         break;
            //     default:
            //         break;
            // }
            // setProjectsList(filteredProjects);
            setFilteredProject(filteredProjects);
            setBuffering(false);

        } catch (error) {
            setBuffering(false);
            console.error('Error fetching contractor projects:', error);
        } finally {
            setBuffering(false);
        }
    };

    // useEffect(() => {
    //     fetchProjects();
    // }, [buffer]);

    useEffect(() => {
        fetchProjects();
    }, [subCompany, searchName, searchSort]); // Refetch projects when filters change


    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const toggleshow = "Contractor";

    const ViewProjectDetails = (project) => {
        navigate(`/${urlParts[3]}/projectDetailsPage/`, {
            state: { project, toggleshow },
        });
    };

    return (
        <>


            <div className=" table-css-white-background  table-box scroll-container-table" style={{ paddingTop: "0px" }}>


                <table ref={tableRef} className="table-css">
                    <thead className="table-heading">
                        <tr className="custom-table-head-tr">
                            <th className="align-left table-heading-text">S.no.</th>

                            <th className="align-center">Project Name</th>
                            <th className="align-center">Consultant</th>
                            <th className="align-center">Sub Contractor</th>

                            <th className="align-center ">Client</th>

                            <th className="align-center" > Actions</th >
                        </tr >
                    </thead >
                    <tbody>
                        {
                            filteredProject.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map((project, index) => (
                                <tr key={project.id} className="custom-table-head-td">
                                    <td className="align-center table-body">{index + 1}</td>

                                    <td className="align-center">{project.project_name || "-"}</td>
                                    <td className="align-center">{project.consultant || "-"}</td>
                                    <td className="align-center">{project.sub_contractor || "-"}</td>
                                    <td className=" align-center">{project.client_name || "-"}</td>

                                    <td className="align-right  width-5vw">
                                        <div className="flex-row justify-around">
                                            <button
                                                onClick={() => ViewProjectDetails(project)}
                                                title="View Project Details"
                                                className="action-button"
                                            >
                                                <Eye />
                                            </button>
                                            {role !== "Hr" && role !== "BD" && role !== "Account" && (
                                                <DeleteProject
                                                    i={project}
                                                    refreshProjects={fetchProjects}
                                                />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table >
            </div >
        </>
    );
};


const SiteProjectTable = ({ toggleProject, setToggleProject }) => {
    const [projectList, setProjectList] = useState([]);
    // const [toggleProject, setToggleProject] = useState("")

    const [toggleCompany, setToggleCompany] = useState("null");
    const [selectedName, setSelectedName] = useState("null");
    const [selectedCC, setSelectedCC] = useState('contractor');
    const [sorting, setSorting] = useState("asc_pr");
    const role = sessionStorage.getItem('role');

    const getProjects = async () => {
        const role = sessionStorage.getItem("role");
        const empId = sessionStorage.getItem("SuperAdmin");

        let endpoint = "";


        endpoint = `${BASE_URL}/project_details/project/`;


        const pro = await axios.get(endpoint);
        setProjectList(pro.data);
        console.log("pro.data")
        console.log(pro.data)

    }
    // Function to fetch projects for contractors


    useEffect(() => {
        getProjects();
    }, []);


    const [projectListfilter, setProjectListfilter] = useState([]);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);



    // Event handlers
    const handleSortChange = (e) => setSorting(e.target.value);
    const handleCCChange = (e) => setSelectedCC(e.target.value);
    const options = projectList
        // .sort((a, b) => a.emp_code - b.emp_code)
        .map((i) => ({
            value: i.id,
            label: `${i.site_prcode} - ${i.project_short_name}`,
        }));

    const handleChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedName(selectedOption.value);
        } else {
            setSelectedName("");
        }
    };

    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
    };
    const [selectedFromDate, setFromDate] = useState(null);
    const [selectedToDate, setToDate] = useState(null);
    const handleClearAllFilter = () => {

        setFromDate(null);
        setToDate(null);
    };

    useEffect(() => {
        getProjects();

    }, [selectedFromDate, selectedToDate])

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Dashboardnavbar name="All Projects" url="Projects" />

            <div className="content-tabs">
                <div>
                    <div className="attendance-subcont">
                        <div className="field-cont">


                            <div title="Date Range Filter" className="field-cont-div ">
                                <DateRangePicker startDate={selectedFromDate} endDate={selectedToDate} placeHolder1="From Date" placeHolder2="To Date" onChange={(start, end) => {
                                    setFromDate(start);
                                    setToDate(end);
                                }} />
                                <hr className="field-cont-hr" />
                            </div>
                            <div style={{ color: '#2576bc', cursor: 'pointer' }} onClick={handleClearAllFilter}>Clear All</div>

                        </div>

                        {role === "Hr" || role === "Account" ? "" :
                            <div className="btn-cont">
                                {/* <DownloadSiteProject projectList={projectList} /> */}
                                <AddProjectDetails getProjects={getProjects} />
                                {/* {role === "Admin" &&
                                    <UploadSiteProject getProject={getProjects} ProjectList={projectList} getContractorProjects={getProjects} />
                                } */}
                            </div>
                        }
                    </div>
                </div>

                <ProjectDataTableView
                    subCompany={toggleCompany}
                    searchName={selectedName}
                    searchSort={sorting}
                />
            </div>
        </>
    );
};

const ProjectDetailsPage = () => {
    const location = useLocation();
    // const { projectID } = usePermission();

    const projectIdd = location.state?.project?.id ? location.state?.project?.id : location?.state?.project;
    const [buffer, setBuffering] = useState(false);
    console.log(projectIdd, 'location')
    // State Variables
    const [projectData, setProjectsData] = useState();
    const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
    const [siteProject, setSiteProject] = useState();
    const [allDepartmentlist, setAllDepartmentlist] = useState([]);

    const role = sessionStorage.getItem('SuperAdmin')
    // Function to Fetch Project Data
    const getProjects = async () => {
        setBuffering(true);
        try {
            const sub = await axios.get(`${BASE_URL}/configuration/subcompany/`);
            setSiteSubCompanyList(sub.data);

            const dep = await axios.get(`${BASE_URL}/configuration/department/`);
            setAllDepartmentlist(dep.data);

            const proj = await axios.get(`${BASE_URL}/project_details/projectbyid/${projectIdd}/`);
            setProjectsData(proj.data);

        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        if (projectIdd != undefined && projectIdd != "") {
            getProjects();
        }

    }, [projectIdd]);

    const [toggleProjectDetailDisplay, setToggleProjectDetailDisplay] = useState(1);


    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <Dashboardnavbar name={`Project Details`} url="Project" />

            <div className="content-tabs">

                <div className="info-box-div-bg">
                    <div className="jd-heading-outer heading-bg-color-white">
                        <div className="jd-heading-outer-flex">
                            <h2 className="jd-heading-main font-weight600 font-size-heading">
                                Project Details of "{projectData?.site_prcode || '-'}: {projectData?.project_short_name || '-'}"
                            </h2>
                            <UpdateProjectAllDetails
                                i={projectData}
                                getProjects={getProjects}
                                siteSubCompanyList={siteSubCompanyList}
                            />
                        </div>
                        <div>
                            <div className="jd-heading-bottom-bold"></div>
                            <div className="jd-heading-bottom-light"></div>
                        </div>
                    </div>

                    {/* Project Details Table */}
                    <div className="personal-detail-table">
                        <div>
                            <table>
                                <tbody>
                                    {/* Basic Information */}

                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Project Name</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.project_name || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Short Name</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.project_short_name || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Location</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.location || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Client Name</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.client_name || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Tender ID</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.tender_id || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Project Length</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.project_length || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Regional Office (RO)</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.ro || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Project Mode</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.project_mode || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Project Form</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.project_form || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Project To</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.project_to || '-'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <table>
                                <tbody>
                                    {/* Dates Section */}
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Bid Due Date</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.bid_due_date ? new Date(projectData.bid_due_date).toLocaleDateString() : '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Agreement Date</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.agreement_date ? new Date(projectData.agreement_date).toLocaleDateString() : '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Commencement Date</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.commencement_date ? new Date(projectData.commencement_date).toLocaleDateString() : '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Appointment Date</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.Appointment_date ? new Date(projectData.Appointment_date).toLocaleDateString() : '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Project Completion Date</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.project_completion_date ? new Date(projectData.project_completion_date).toLocaleDateString() : '-'}
                                        </td>
                                    </tr>

                                    {/* Durations */}
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Project Duration (months)</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.project_duration || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Construction Duration</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.construction_duration || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">O&M Duration</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.om_duration || '-'}
                                        </td>
                                    </tr>

                                    {/* Financial Information */}
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Consultancy Fees</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.consultancy_fees || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Our Share</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.our_share ? `${projectData.our_share}` : '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">JV Share</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.jv_share || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Bid Security</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.bid_security || '-'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Contract Mode</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.contract_mode || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Status</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.status || '-'}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Concern Person</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.concern_person_name || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">RO Address</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.ro_address || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">PIU Address</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.piu_address || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">SPV</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.spv || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">NH No</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.nh_no || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Name of DPR Consultant</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.name_of_dpr_consultant || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">RFP Invited</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.RFP_invited || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">LOR</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.LOR || '-'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">CA Signed</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.CA_signed || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">BPC of Concessionaire</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.BPC_of_concessionaire || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">EPC</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.EPC || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Performance Security</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.performance_security || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Additional Performance Security</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.additional_performance_security || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Mobilization Advance After AD</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.mobilization_advance_after_AD || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Approval of GAD of ROB</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.approval_of_GAD_of_ROB || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Lead</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.lead || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">JV</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.jv || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Association</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.association || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Our Services</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.our_services || '-'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Project Key Points</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.project_key_point || '-'}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Consultant</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.consultant || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Sub Contractor</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.sub_contractor || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Request Raised by AE</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.req_raised_by_AE || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Escalation</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.esclation || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Is Escalation Added</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.is_escalation_added ? 'Yes' : 'No'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Admin Approval for DLT</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.admin_approval_for_dlt ? 'Yes' : 'No'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Created At</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.created_at ? new Date(projectData.created_at).toLocaleDateString() : '-'}
                                        </td>
                                    </tr>
                                    {/* File Uploads */}
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Notice Invite Tender Document</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.notice_intivite_tender_id ? (
                                                <a href={projectData.notice_intivite_tender_id} target="_blank" rel="noopener noreferrer">
                                                    View Document
                                                </a>
                                            ) : '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Agreement File</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.agreement_file_upload ? (
                                                <a href={projectData.agreement_file_upload} target="_blank" rel="noopener noreferrer">
                                                    View Document
                                                </a>
                                            ) : '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">Commencement File</td>
                                        <td className="personal-detail-2 font-weight500 font-size-text">
                                            {projectData?.commencement_file_upload ? (
                                                <a href={projectData.commencement_file_upload} target="_blank" rel="noopener noreferrer">
                                                    View Document
                                                </a>
                                            ) : '-'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {
                    <div className="filter-outer-box">
                        <div>
                            <button
                                className={
                                    toggleProjectDetailDisplay === 1
                                        ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponents-tabs-color"
                                }
                                onClick={() => setToggleProjectDetailDisplay(1)}
                            >
                                Department
                            </button>

                            <button
                                className={
                                    toggleProjectDetailDisplay === 2
                                        ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponents-tabs-color"
                                }
                                onClick={() => setToggleProjectDetailDisplay(2)}
                            >
                                Party
                            </button>

                            <button
                                className={
                                    toggleProjectDetailDisplay === 3
                                        ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponents-tabs-color"
                                }
                                onClick={() => setToggleProjectDetailDisplay(3)}
                            >
                                MOM
                            </button>

                            <button
                                className={
                                    toggleProjectDetailDisplay === 4
                                        ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponents-tabs-color"
                                }
                                onClick={() => setToggleProjectDetailDisplay(4)}
                            >
                                Rob
                            </button>
                            <button
                                className={
                                    toggleProjectDetailDisplay === 5
                                        ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponents-tabs-color"
                                }
                                onClick={() => setToggleProjectDetailDisplay(5)}
                            >
                                Project Material
                            </button>
                            <button
                                className={
                                    toggleProjectDetailDisplay === 6
                                        ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponents-tabs-color"
                                }
                                onClick={() => setToggleProjectDetailDisplay(6)}
                            >
                                Critical Activity
                            </button>
                            <button
                                className={
                                    toggleProjectDetailDisplay === 7
                                        ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponents-tabs-color"
                                }
                                onClick={() => setToggleProjectDetailDisplay(7)}
                            >
                                Production
                            </button>
                        </div>
                    </div>
                }


                <div>
                    {toggleProjectDetailDisplay === 1 ?
                        <ProjectDetailsDepartment buffer={buffer} projectId={projectIdd} projectData={projectData} getProjects={getProjects} allDepartmentlist={allDepartmentlist} />
                        : null}
                    {toggleProjectDetailDisplay === 2 ?
                        <ProjectDetailsParty projectId={projectIdd} getProjects={getProjects} />
                        : null}
                    {toggleProjectDetailDisplay === 3 ?
                        <ProjectDetailsMOM projectId={projectIdd} getProjects={getProjects} />
                        : null}
                    {toggleProjectDetailDisplay === 4 ?
                        <ProjectRobTable projectId={projectIdd} getProjects={getProjects} />
                        : null}
                    {toggleProjectDetailDisplay === 5 ?
                        <MaterialTable projectId={projectIdd} getProjects={getProjects} />
                        : null}
                    {toggleProjectDetailDisplay === 6 ? <ProjectDetailsCriticalActivity projectId={projectIdd} getProjects={getProjects} /> : null}
                    {toggleProjectDetailDisplay === 7 ? <ProjectDetailsProductionActivity projectId={projectIdd} getProjects={getProjects} /> : null}
                </div>

                {/* <AllLetterDetails projectID={projectIdd} /> */}
            </div >
        </>
    );
};

const ContractorDetails = ({ contractor, getProjects, getContractorDetails, getProjectContractorDetails }) => {

    const role = sessionStorage.getItem('SuperAdmin');

    const [buffer, setBuffering] = useState(false);
    const [consultancyDetailsDetails, setConsultancyDetailsData] = useState([]);


    useEffect(() => {
        console.log("useffect running")
        getConsultancyDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contractor]);

    const getConsultancyDetails = async () => {
        setBuffering(true);
        try {
            const response = await axios.get(
                `${BASE_URL}/project_details/contractor/${contractor}/`
            );
            setConsultancyDetailsData(response.data);
        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };



    const formatRoundoff = (amount) => {
        if (amount === null || amount === undefined) return "-";

        // Function to format the number with Indian number system
        const formatIndianStyle = (num) => {
            let numStr = num.toString();
            let lastThreeDigits = numStr.slice(-3);
            let otherDigits = numStr.slice(0, -3);

            if (otherDigits) {
                lastThreeDigits = ',' + lastThreeDigits;
            }

            // Split other digits into groups of two and add commas
            const formattedOtherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',');

            return formattedOtherDigits + lastThreeDigits;
        };



        return formatIndianStyle(amount)
    };



    return (
        <>

            <div className="info-box-div-bg">

                <div className="heading-bg-color-white">
                    <div className="jd-heading-outer-flex ">
                        <h2 className="jd-heading-main font-weight600  font-size-heading">Party Details:</h2>
                        <div className="field-cont">
                            {role !== "SuperAdmin" &&
                                <>
                                    <UpdateConsultant contractor={contractor} getContractorDetails={getConsultancyDetails} projectId={consultancyDetailsDetails?.project} i={consultancyDetailsDetails} getProjectContractorDetails={getProjectContractorDetails} />
                                    <DeleteContractor contractor={contractor} getContractorDetails={getContractorDetails} getproject={getProjects} getProjectContractorDetail={getProjectContractorDetails} consultancyDetailsDetails={consultancyDetailsDetails} />
                                </>
                            }
                        </div>
                    </div>
                    <div>
                        <div className="jd-heading-bottom-bold"></div>
                        <div className="jd-heading-bottom-light"></div>
                    </div>
                </div>


                <div className="info-box-div">
                    <div className="personal-detail">

                        {buffer ? <div className="spinner-smalll"></div> :
                            <table className="width-40vw">
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text ">Contractor Business Name</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text "> {consultancyDetailsDetails?.name
                                        ? consultancyDetailsDetails.name.split(" - ")[0] || consultancyDetailsDetails.name
                                        : "-"}</th>
                                </tr >


                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text ">Contractor address</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.contractor_address ? consultancyDetailsDetails?.contractor_address : "-"}</th>
                                </tr >






                            </table >
                        }
                    </div >
                    <div className="personal-detail">
                        {buffer ? <div className="spinner-smalll"></div> :
                            <table className="width-40vw">
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text ">Contractor Client Name</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text "> {consultancyDetailsDetails?.name
                                        ? consultancyDetailsDetails.name.split(" - ")[1] || consultancyDetailsDetails.name
                                        : "-"}</th>
                                </tr >
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text ">Contractor Work Type</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.work_type ? consultancyDetailsDetails?.work_type : "-"}</th>
                                </tr >
                                {/* <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text ">Contractor LOA Date</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.loa_award_date ? formattedDateLong(consultancyDetailsDetails?.loa_award_date) : "-"}</th>
                                </tr > */}
                                {/* <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text ">Contractor Agreement Date</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.agreement_date ? formattedDateLong(consultancyDetailsDetails?.agreement_date) : "-"}</th>
                                </tr > */}
                                {/* <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text ">Contractor Commencement Date</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.commencement_date ? formattedDateLong(consultancyDetailsDetails?.commencement_date) : "-"}</th>
                                </tr > */}
                                {/* <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text ">Schedule Construction Completion Date</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.schedule_construction_completion_date ? formattedDateLong(consultancyDetailsDetails?.schedule_construction_completion_date) : "-"}</th>
                                </tr > */}
                                {/* <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text ">Actual Construction Completion Date</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.actual_construction_completion_date ? formattedDateLong(consultancyDetailsDetails?.actual_construction_completion_date) : "-"}</th>
                                </tr > */}
                                {/* <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text ">Contractor Schedule Completion Date</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.schedule_completion_date ? formattedDateLong(consultancyDetailsDetails?.schedule_completion_date) : "-"}</th>
                                </tr > */}

                                {/* <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text ">Contractor Actual Completion Date</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.actual_completion_date ? formattedDateLong(consultancyDetailsDetails?.actual_completion_date) : "-"}</th>
                                </tr > */}



                            </table >
                        }
                    </div >




                </div >
            </div>

        </>
    )
}

const ProjectDetailsDepartment = ({ buffer, projectId, projectData, getProjects, allDepartmentlist }) => {
    const [toggleState2, settoggleState2] = useState(1);


    return (
        <>
            {
                <div className="filter-outer-box padding-x">
                    <div
                        className="toggle-button-area"
                        style={{
                            padding: "0px 0px 0px 0px",
                            width: "100%",
                        }}
                    >
                        <div className="left-expense-bloc-tab">
                            <div>
                                {
                                    buffer ? <div className="spinner-small"></div> :

                                        projectData?.departments.length > 0 && projectData?.departments.map((dept, index) => (
                                            <button
                                                // key={dept.id}
                                                className={
                                                    toggleState2 === index + 1
                                                        ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponents-tabs-color"
                                                }
                                                onClick={() => settoggleState2(index + 1)}
                                            >
                                                {/* {dept?.division_name} */}
                                                {allDepartmentlist.find((opt) => opt.id === dept)?.title}
                                            </button>
                                        ))}
                            </div>

                        </div>
                        <div className="right-expense-bloc-tab">
                            <div>
                                <AddEditProjectDepartment
                                    projectID={projectId}
                                    getDepartmentList={getProjects}
                                    departmentlist={projectData?.departments}
                                    allDepartmentlist={allDepartmentlist}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }

            <>

                {projectData?.departments.length > 0 && projectData?.departments.map((dept, index) => {
                    console.log("yes")
                    return toggleState2 === index + 1 ? (
                        <DepartmentTask
                            key={index}
                            projectId={projectId}
                            departmentId={dept}
                            getDepartmentList={getProjects}
                            departmentlist={projectData?.departments}
                        />
                    ) : null;
                })}

            </>

        </>
    )
}

const ProjectDetailsParty = ({ projectId, getProjects }) => {

    const [toggleState, setToggleState] = useState("contractor");
    const [toggleStatechange, setToggleStatechange] = useState(10);
    const [contractorlist, setContractorList] = useState([]);
    const [contractor, setContractor] = useState(null);
    const [consultancyDetailsDetails, setConsultancyDetailsData] = useState([]);
    const [buffer, setBuffering] = useState(false);

    const getProjectContractorDetails = async () => {

        setBuffering(true);
        try {
            const contractordetails = await axios.get(
                `${BASE_URL}/project_details/contractorbyproject/${projectId}/`
            );
            setContractorList(contractordetails.data);

            if (contractordetails.data.length > 0) {
                setContractor(contractordetails.data.slice(-1)[0]?.id); // Using slice to get the last contractor
            } else {
                setContractor(undefined); // or handle it accordingly
            }
        } catch (err) {
            // handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    const getConsultancyDetails = async () => {
        setBuffering(true);
        try {
            const response = await axios.get(
                `${BASE_URL}/project_details/contractor/${contractor}/`
            );
            setConsultancyDetailsData(response.data);
        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };


    useEffect(() => {
        if (toggleState === "contractor") {
            getProjectContractorDetails();
            // Set default toggleStatechange for contractor view
            setToggleStatechange(10);
        }
        if (toggleState === "consultant") {
            setToggleStatechange(11); // Set to consultant default
            setContractor(null)
        }
        // Add additional logic if needed
    }, [toggleState]);

    return (
        <>
            <div className="filter-outer-box">
                <div className="field-cont">
                    <>
                        <div title="Contractor Name" className="field-cont-div">
                            <ProjectIcon />
                            <select
                                onChange={(e) => setContractor(e.target.value === "" ? undefined : e.target.value)} // Set undefined if the value is empty
                                value={contractor || ""} // Default to empty string if contractor is undefined
                                className="attendance-input-field date-field"
                            >

                                <option value="">{Array.isArray(contractorlist) && contractorlist.length > 0 ? 'Select a Party' : 'Add a Party First'}</option>
                                {contractorlist.map((e) => (
                                    <option key={e.id} value={e.id}>{e.name}</option>
                                ))}
                            </select>
                        </div>
                    </>
                </div>

                <div className="btn-cont">
                    <AddConsultant projectId={projectId} getProjects={getProjects} getProjectConsultantDetails={getProjectContractorDetails} getDetails={getConsultancyDetails} />
                </div>


            </div>
            {Array.isArray(contractorlist) && contractorlist.length > 0 ? (
                <>
                    <div className="info-box-div-without-bg">
                        {toggleState === "contractor" && <ContractorDetails projectId={projectId} contractor={contractor} getProjectContractorDetails={getProjectContractorDetails} />}
                    </div>
                </>
            ) : (<div className="info-box-div-without-bg">
                <div className="filter-outer-box">
                    <p style={{ textAlign: "center", color: "#2576bc" }}>No Party Found</p>
                </div>
            </div>)

            }

        </>
    )
}


const ProjectDetailsMOM = ({ projectId, getProjects }) => {
    // console.log(projectId, "projectid")
    const [buffer, setBuffering] = useState(false);
    const [momList, setMOMList] = useState([]);

    const getMOMList = async () => {
        setBuffering(true);
        try {
            const mom = await axios.get(`${BASE_URL}/project_details/momfilterbyproject/${projectId}/`);
            console.log("mom.data", mom.data)
            setMOMList(mom.data)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        console.log("useeffect running", projectId)
        if (projectId) {

            getMOMList()
        }

    }, [projectId]);

    return (
        <>
            <div className="filter-outer-box">
                <div className="field-cont">
                    {/* <div title="Contractor Name" className="field-cont-div">
                            <ProjectIcon />
                            <select
                                onChange={(e) => setContractor(e.target.value === "" ? undefined : e.target.value)} // Set undefined if the value is empty
                                value={contractor || ""} // Default to empty string if contractor is undefined
                                className="attendance-input-field date-field"
                            >

                                <option value="">{Array.isArray(contractorlist) && contractorlist.length > 0 ? 'Select a Party' : 'Add a Party First'}</option>
                                {contractorlist.map((e) => (
                                    <option key={e.id} value={e.id}>{e.name}</option>
                                ))}
                            </select>
                        </div> */}
                </div>

                <div className="btn-cont">
                    <AddMOM projectID={projectId} getMOMList={getMOMList} />
                    {/* <AddConsultant projectId={projectId} getProjects={getProjects} getProjectConsultantDetails={getProjectContractorDetails} getDetails={getConsultancyDetails} /> */}
                </div>


            </div>

            <div className="table-css-white-background">
                <div className="table-box scroll-container-table">
                    <table className="table-css">
                        <thead className="table-heading">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text">Sr no.</th>
                                <th className="table-heading-text">Description</th>
                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text">Meeting Date</th>
                                <th className="table-heading-text">Location</th>
                                <th className="table-heading-text">Attendees Count</th>
                                <th className="table-heading-text">Assigned By</th>
                                <th className="table-heading-text">Mode Of Meeting</th>
                                <th className="table-heading-text">Assignments</th>
                                <th className="table-heading-text">Created At</th>
                                <th className="table-heading-text text-center">
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner-bgdatil"></div> //buffering logic
                        ) : (
                            <tbody>
                                {momList
                                    .sort((a, b) => new Date(b.meeting_date) - new Date(a.meeting_date))
                                    .map((i, index) => (
                                        <React.Fragment key={i.id}>
                                            <tr className="custom-table-head-td">
                                                <td className="table-body">{index + 1}</td>
                                                <td className="table-body" style={{ maxWidth: "300px", whiteSpace: "pre-wrap" }}>
                                                    {i.description}
                                                </td>
                                                <td className="table-body">
                                                    <span className={`status-badge ${i.status}`}>
                                                        {i.status.charAt(0).toUpperCase() + i.status.slice(1)}
                                                    </span>
                                                </td>
                                                <td className="table-body">
                                                    {i.meeting_date ? new Date(i.meeting_date).toLocaleString() : '-'}
                                                </td>
                                                <td className="table-body">{i.location || '-'}</td>
                                                <td className="table-body text-center">
                                                    {i.attendees?.length || 0}
                                                </td>
                                                <td className="table-body text-center">
                                                    {i.assigned_by}
                                                </td>
                                                <td className="table-body text-center">
                                                    {i.mode_of_meeting}
                                                </td>
                                                <td className="table-body">
                                                    <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
                                                        <table style={{ width: '100%' }}>
                                                            <thead>
                                                                <tr>
                                                                    <th>Assignment ID</th>
                                                                    <th>Status</th>
                                                                    <th>Points</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {i.assignments?.map(assignment => (
                                                                    <tr key={assignment.id}>
                                                                        <td>{assignment.id.substring(0, 8)}...</td>
                                                                        <td>
                                                                            <span className={`status-badge ${assignment.status}`}>
                                                                                {assignment.status.charAt(0).toUpperCase() + assignment.status.slice(1)}
                                                                            </span>
                                                                        </td>
                                                                        <td>{assignment.points || '-'}</td>
                                                                    </tr>
                                                                ))}

                                                                {!i.assignments?.length && (
                                                                    <tr>
                                                                        <td colSpan="3">No assignments</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </td>
                                                <td className="table-body">
                                                    {new Date(i.created_at).toLocaleDateString()}
                                                </td>
                                                <td className="table-body text-right" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                                    <UpdateMOM
                                                        mom={i}
                                                        getMOMList={getMOMList}
                                                    />
                                                    <DeleteMOM
                                                        mom={i}
                                                        getMOMList={getMOMList}
                                                    />
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>

        </>
    )
}



const ProjectRobTable = ({ projectID, department_name }) => {
    const [robList, setRobList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [buffer, setBuffer] = useState(false);

    // Fetch ROB list
    const getROBList = async () => {
        setBuffer(true);
        try {
            const res = await axios.get(`${BASE_URL}/project_details/rob/`);
            setRobList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffer(false);
        }
    };

    useEffect(() => {
        getROBList();
    }, [projectID, department_name]);

    return (
        <>
            <div className="filter-outer-box">
                <div className="field-cont">
                    {/* <div title="Contractor Name" className="field-cont-div">
                            <ProjectIcon />
                            <select
                                onChange={(e) => setContractor(e.target.value === "" ? undefined : e.target.value)} // Set undefined if the value is empty
                                value={contractor || ""} // Default to empty string if contractor is undefined
                                className="attendance-input-field date-field"
                            >

                                <option value="">{Array.isArray(contractorlist) && contractorlist.length > 0 ? 'Select a Party' : 'Add a Party First'}</option>
                                {contractorlist.map((e) => (
                                    <option key={e.id} value={e.id}>{e.name}</option>
                                ))}
                            </select>
                        </div> */}
                </div>

                <div className="btn-cont">
                    <AddROB
                        projectID={projectID}
                        getROBList={getROBList}
                        department_name={department_name}
                    />
                    {/* <AddConsultant projectId={projectId} getProjects={getProjects} getProjectConsultantDetails={getProjectContractorDetails} getDetails={getConsultancyDetails} /> */}
                </div>


            </div>
            <div className="table-css-white-background">
                <div className="table-box scroll-container-table">


                    <table className="table-css">
                        <thead className="table-heading">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text">Sr no.</th>
                                <th className="table-heading-text">Activity</th>
                                <th className="table-heading-text">Yesterday's Status</th>
                                <th className="table-heading-text">Today's Status</th>
                                <th className="table-heading-text">Target This Week</th>
                                <th className="table-heading-text">Target For This Month</th>
                                <th className="table-heading-text">Reason for Pending</th>
                                <th className="table-heading-text">Action To Be Taken</th>
                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text">Parent Rob</th>
                                <th className="table-heading-text text-center">Actions</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner-bgdatil"></div>
                        ) : (
                            <tbody>
                                {robList.map((rob, index) => (
                                    <tr key={rob.id} className="custom-table-head-td">
                                        <td className="table-body">{index + 1}</td>
                                        <td className="table-body">{rob.activity || '-'}</td>
                                        <td className="table-body">{rob.status_yesterday || '-'}</td>
                                        <td className="table-body">{rob.status_today || '-'}</td>
                                        <td className="table-body">{rob.target_this_week || '-'}</td>
                                        <td className="table-body">{rob.target_for_this_month || '-'}</td>
                                        <td className="table-body">{rob.reason_for_pending || '-'}</td>
                                        <td className="table-body">
                                            {rob.action_to_be_taken?.name || '-'}
                                        </td>
                                        <td className="table-body">
                                            <span className={`status-badge ${rob.status}`}>
                                                {rob.status?.charAt(0).toUpperCase() + rob.status?.slice(1) || '-'}
                                            </span>
                                        </td>
                                        <td className="table-body">
                                            {rob.parent_rob ? rob.parent_rob_name : '-'}
                                        </td>
                                        <td className="table-body text-right" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                            <UpdateROB
                                                rob={rob}
                                                getROBList={getROBList}
                                                department_name={department_name}
                                            />
                                            <DeleteROB
                                                rob={rob}
                                                getROBList={getROBList}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        </>
    );
};




const MaterialTable = ({ projectID, department_name }) => {
    const [materialList, setMaterialList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [buffer, setBuffer] = useState(false);

    // Fetch Material list
    const getMaterialList = async () => {
        setBuffer(true);
        try {
            const res = await axios.get(`${BASE_URL}/project_details/material/`);
            setMaterialList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffer(false);
        }
    };

    useEffect(() => {
        getMaterialList();
    }, [projectID, department_name]);

    return (

        <>
            <div className="filter-outer-box">
                <div className="field-cont">
                    {/* <div title="Contractor Name" className="field-cont-div">
                            <ProjectIcon />
                            <select
                                onChange={(e) => setContractor(e.target.value === "" ? undefined : e.target.value)} // Set undefined if the value is empty
                                value={contractor || ""} // Default to empty string if contractor is undefined
                                className="attendance-input-field date-field"
                            >

                                <option value="">{Array.isArray(contractorlist) && contractorlist.length > 0 ? 'Select a Party' : 'Add a Party First'}</option>
                                {contractorlist.map((e) => (
                                    <option key={e.id} value={e.id}>{e.name}</option>
                                ))}
                            </select>
                        </div> */}
                </div>

                <div className="btn-cont">
                    <AddMaterial
                        projectID={projectID}
                        getMaterialList={getMaterialList}
                        department_name={department_name}
                    />
                    {/* <AddConsultant projectId={projectId} getProjects={getProjects} getProjectConsultantDetails={getProjectContractorDetails} getDetails={getConsultancyDetails} /> */}
                </div>


            </div>
            <div className="table-css-white-background">
                <div className="table-box scroll-container-table">


                    <table className="table-css">
                        <thead className="table-heading">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text">Sr no.</th>
                                <th className="table-heading-text">Item Description</th>
                                <th className="table-heading-text">Unit</th>
                                <th className="table-heading-text">Project Scope Qty</th>
                                <th className="table-heading-text">Received Today</th>
                                <th className="table-heading-text">Received This Month</th>
                                <th className="table-heading-text">Upto Date Received</th>
                                <th className="table-heading-text">Balance to Procure</th>
                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text">Created At</th>
                                <th className="table-heading-text text-center">Actions</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner-bgdatil"></div>
                        ) : (
                            <tbody>
                                {materialList.map((material, index) => (
                                    <tr key={material.id} className="custom-table-head-td">
                                        <td className="table-body">{index + 1}</td>
                                        <td className="table-body">{material.item_description || '-'}</td>
                                        <td className="table-body">{material.unit || '-'}</td>
                                        <td className="table-body">{material.project_scope_quantity || '-'}</td>
                                        <td className="table-body">{material.received_today || '-'}</td>
                                        <td className="table-body">{material.received_this_month || '-'}</td>
                                        <td className="table-body">{material.upto_date_received || '-'}</td>
                                        <td className="table-body">{material.balance_to_be_procure || '-'}</td>
                                        <td className="table-body">
                                            <span className={`status-badge ${material.status}`}>
                                                {material.status?.charAt(0).toUpperCase() + material.status?.slice(1) || '-'}
                                            </span>
                                        </td>
                                        <td className="table-body">
                                            {material.created_at ? new Date(material.created_at).toLocaleDateString() : '-'}
                                        </td>
                                        <td className="table-body text-right" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                            <UpdateMaterial
                                                material={material}
                                                getMaterialList={getMaterialList}
                                                department_name={department_name}
                                            />
                                            <DeleteMaterial
                                                material={material}
                                                getMaterialList={getMaterialList}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        </>
    );
};

const ProjectDetailsCriticalActivity = ({ projectId, getProjects }) => {
    // console.log(projectId, "projectid")
    const [buffer, setBuffering] = useState(false);
    const [criticalactivityList, setCriticalactivityList] = useState([]);

    const getCriticalList = async () => {
        setBuffering(true);
        try {
            // const mom = await axios.get(`${BASE_URL}/project_details/criticalactivities/${projectId}/`);
            const mom = await axios.get(`${BASE_URL}/project_details/criticalactivityfilterbyproject/${projectId}/`);
            setCriticalactivityList(mom.data)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        console.log("useeffect running", projectId)
        if (projectId) {

            getCriticalList()
        }

    }, [projectId]);

    return (
        <>
            <div className="filter-outer-box">
                <div className="field-cont">

                </div>

                <div className="btn-cont">
                    <CriticalActivityModal projectID={projectId} getCriticalList={getCriticalList} />
                    {/* <AddConsultant projectId={projectId} getProjects={getProjects} getProjectConsultantDetails={getProjectContractorDetails} getDetails={getConsultancyDetails} /> */}
                </div>


            </div>

            <div className="table-css-white-background">
                <div className="table-box scroll-container-table">
                    <table className="table-css">
                        <thead className="table-heading">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text">Sr no.</th>
                                <th className="table-heading-text">Critical Activity Name</th>
                                <th className="table-heading-text">Description</th>
                                <th className="table-heading-text">Reason</th>
                                <th className="table-heading-text">Action To Be Taken</th>
                                <th className="table-heading-text">Duration Time</th>
                                <th className="table-heading-text">Issue Raised On</th>
                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text text-center">
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <tbody>
                                <tr>
                                    <td colSpan="9" className="text-center">
                                        <div className="spinner-bgdatil"></div>
                                    </td>
                                </tr>
                            </tbody>
                        ) : (
                            <tbody>
                                {criticalactivityList
                                    .sort((a, b) => new Date(b.issue_raised_on) - new Date(a.issue_raised_on))
                                    .map((i, index) => (
                                        <React.Fragment key={i.id}>
                                            <tr className="custom-table-head-td">
                                                <td className="table-body">{index + 1}</td>
                                                <td className="table-body" style={{ maxWidth: "200px" }}>
                                                    {i.critical_activity_name}
                                                </td>
                                                <td className="table-body" style={{ maxWidth: "300px", whiteSpace: "pre-wrap" }}>
                                                    {i.description}
                                                </td>
                                                <td className="table-body" style={{ maxWidth: "250px", whiteSpace: "pre-wrap" }}>
                                                    {i.reason}
                                                </td>
                                                <td className="table-body" style={{ maxWidth: "250px", whiteSpace: "pre-wrap" }}>
                                                    {i.action_to_taken}
                                                </td>
                                                <td className="table-body text-center">
                                                    {i.duration_time}
                                                </td>
                                                <td className="table-body">
                                                    {i.issue_raised_on ? new Date(i.issue_raised_on).toLocaleDateString() : '-'}
                                                </td>
                                                <td className="table-body">
                                                    <span className={`status-badge ${i.status}`}>
                                                        {i.status.charAt(0).toUpperCase() + i.status.slice(1)}
                                                    </span>
                                                </td>
                                                <td className="table-body text-right" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                                    <CriticalEditActivityModal
                                                        i={i}
                                                        getCriticalListt={getCriticalList}
                                                    />
                                                    <CriticalActivityModalDelete
                                                        i={i}
                                                        getCriticalList={getCriticalList}
                                                    />
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}

                                {criticalactivityList.length === 0 && (
                                    <tr>
                                        <td colSpan="9" className="text-center table-body">
                                            No critical activities found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        )}
                    </table>
                </div>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>

        </>
    )
}

const ProjectDetailsProductionActivity = ({ projectId, getProjects }) => {
    // console.log(projectId, "projectid")
    const [buffer, setBuffering] = useState(false);
    const [ProductionactivityList, setProductionactivityList] = useState([]);

    const getProductionList = async () => {
        setBuffering(true);
        try {
            // const mom = await axios.get(`${BASE_URL}/project_details/Productionactivities/${projectId}/`);
            const mom = await axios.get(`${BASE_URL}/project_details/productionfilterbyproject/${projectId}/`);
            console.log("mom.data", mom.data);
            setProductionactivityList(mom.data);

        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        console.log("useeffect running", projectId)
        if (projectId) {

            getProductionList()
        }

    }, [projectId]);

    return (
        <>
            <div className="filter-outer-box">
                <div className="field-cont">

                </div>

                <div className="btn-cont">
                    <ProductionModalAdd projectID={projectId} getProductionList={getProductionList} />

                    {/* <AddConsultant projectId={projectId} getProjects={getProjects} getProjectConsultantDetails={getProjectContractorDetails} getDetails={getConsultancyDetails} /> */}
                </div>


            </div>

            <div className="table-css-white-background">
                <div className="table-box scroll-container-table">
                    <table className="table-css">
                        <thead className="table-heading">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text">Sr no.</th>
                                <th className="table-heading-text">Name</th>
                                <th className="table-heading-text">Quantity</th>

                                <th className="table-heading-text text-right">
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <tbody>
                                <tr>
                                    <td colSpan="9" className="text-center">
                                        <div className="spinner-bgdatil"></div>
                                    </td>
                                </tr>
                            </tbody>
                        ) : (
                            <tbody>
                                {ProductionactivityList
                                    .sort((a, b) => new Date(b.issue_raised_on) - new Date(a.issue_raised_on))
                                    .map((i, index) => (
                                        <React.Fragment key={i.id}>
                                            <tr className="custom-table-head-td ">
                                                <td className="table-body">{index + 1}</td>
                                                <td className="table-body" style={{ maxWidth: "200px" }}>
                                                    {i.name}
                                                </td>

                                                <td className="table-body" style={{ maxWidth: "300px", whiteSpace: "pre-wrap" }}>
                                                    {i.quantity}
                                                </td>

                                                <td className="table-body" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                                    <ProductionModalEdit
                                                        i={i}
                                                        getProductionList={getProductionList}
                                                    />
                                                    <ProductionModalDelete
                                                        i={i}
                                                        getProductionList={getProductionList}
                                                    />
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                {ProductionactivityList.length === 0 && (
                                    <tr>
                                        <td colSpan="9" className="text-center table-body">
                                            No Production Detail found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        )}
                    </table>
                </div>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>

        </>
    )
}


export {
    SiteProjectTable,
    ProjectDetailsPage,

};